import * as React from 'react';
import * as styles from "./Card.css";
import { inject, observer } from 'mobx-react';
import { ThemeStore } from '../../stores';
import { ITheme } from '../../../../interfaces/ITheme';
import { IAIcon } from '../../../icon/Icon';
import { LocalizationService } from '../../../../services/LocalizationService';

export interface IThemeCardProps {
  themeStore?: ThemeStore;
  showSkeleton?: boolean;
  item?: ITheme;
  select?: () => void;
  onClickEdit?: (item: ITheme) => void;
  onClickOpen?: (item: ITheme) => void;
  onClickDelete?: (item: ITheme) => void;
}

export interface IThemeCardState {
  commandBarOpen: boolean;
}

@inject('themeStore')
@observer
export class  IAThemeCard extends React.Component<IThemeCardProps, IThemeCardState> {
  constructor(props: IThemeCardProps) {
    super(props);
    this.state = {
      commandBarOpen: false
    }
  }

  public render(): JSX.Element {
    return (
      <div className={styles.themeCard}>
        {this.props.showSkeleton ?
          <div>
            <div className={styles.skeletonImage} />
            <div className={styles.skeletonHeadline} />
          </div>
          :
          <div className={styles.cardContainer}>
            <div className={styles.colorIcon}
              onClick={() => this.props.select()}
            >
              <svg role="presentation" viewBox="0 0 84 46">
                <rect height="100%" width="100%" fill={this.props.item.IsInverted ? "transparent" : this.props.item.Palette.white} stroke="none"></rect>
                <rect y="0%" height="50%" width="50%" fill={this.props.item.Palette.themePrimary} stroke="none"></rect>
                <rect y="0%" height="50%" width="16.666666666666668%" fill={this.props.item.Palette.themeSecondary} stroke="none" x="50%"></rect>
                <rect y="0%" height="50%" width="16.666666666666668%" fill={this.props.item.Palette.themeTertiary} stroke="none" x="66.66666666666667%"></rect>
                {/* Can also be Palette.accent */}
                <rect y="0%" height="50%" width="16.666666666666668%" fill={this.props.item.Palette.themePrimary} stroke="none" x="83.33333333333334%"></rect>
                <text x="10%" y="84%" fill={this.props.item.Palette.neutralPrimary} role="presentation">Abc</text>
              </svg>
            </div>
            <div className={styles.name}
              onClick={() => this.props.select()}
            >
              {this.props.item.Name}
            </div>
            <div className={styles.cardBarContainer}
              onClick={(e) => {
                e.stopPropagation();
                this.setState({ commandBarOpen: !this.state.commandBarOpen });
              }}
            >
              <div className={styles.cardBarBtn}>
                <IAIcon
                  title="More"
                  size={15}
                  color="#333333"
                />
              </div>
              {this.state.commandBarOpen &&
                <ul className={styles.cardBarItems}>
                  <div
                    className={styles.commandBarItem}
                    key={this.props.item.Name + "_edit"}
                    onClick={() => this.props.onClickEdit(this.props.item)}
                  >
                    <IAIcon
                      title="Edit"
                      size={14}
                      color={"#333333"}
                      style={{
                        float: "left"
                      }}
                    />
                    <div
                      style={{
                        color: "#333333",
                        float: "left",
                        marginLeft: 7
                      }}
                    >
                      {new LocalizationService().strings.Card_CommandBar_Edit}
                    </div>
                  </div>
                  <div
                    className={styles.commandBarItem}
                    key={this.props.item.Name + "_open"}
                    onClick={() => this.props.onClickOpen(this.props.item)}
                  >
                    <IAIcon
                      title="Open"
                      size={14}
                      color={"#333333"}
                      style={{
                        float: "left"
                      }}
                    />
                    <div
                      style={{
                        color: "#333333",
                        float: "left",
                        marginLeft: 7
                      }}
                    >
                      {new LocalizationService().strings.Card_CommandBar_Open}
                    </div>
                  </div>
                  <div
                    className={styles.commandBarItem}
                    key={this.props.item.Name + "_delete"}
                    onClick={() => this.props.onClickDelete(this.props.item)}
                  >
                    <IAIcon
                      title="Close"
                      size={14}
                      color={"#333333"}
                      style={{
                        float: "left"
                      }}
                    />
                    <div
                      style={{
                        color: "#333333",
                        float: "left",
                        marginLeft: 7
                      }}
                    >
                      {new LocalizationService().strings.Card_CommandBar_Delete}
                    </div>
                  </div>
                </ul>
              }
            </div>
          </div>
        }
      </div>
    );
  }
}             